// import React, { useState } from 'react';
import styled from 'styled-components/macro';
// import styled, { css } from 'styled-components/macro';

import StakingSidebar from './Staking/StakingSidebar';
import StakingTable from './Staking/StakingTable';
// import SelectAssets from '../../UI/SelectAssets';
// import Search from '../../UI/Search';

const Layout = styled.div`
  display: grid;
  grid-template-columns: 1fr 420px;
  gap: 45px;

  height: 100%;
`;

const Sidebar = styled.div`
  padding-left: 45px;
  height: 100%;

  border-left: 1px solid ${props => props.theme.bg4};
`;

// const StakingHeader = styled.header`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;

//   height: 32px;

//   position: relative;
// `;

// const ButtonsWrapper = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: start;
//   gap: 8px;

//   width: 100%;
// `;

// const SearchSelectWrapper = styled.div`
//   display: flex;
//   justify-content: end;
//   align-items: center;

//   width: 100%;
// `;

// const SelectFilterWrapper = styled.div`
//   display: flex;
//   align-items: center;

//   margin-left: 20px;
// `;

// const inactiveDisplayButton = css`
//   height: auto;

//   background: transparent;
//   box-shadow: none;

//   color: ${props => props.theme.text1};
// `;

// const DisplayButton = styled.button<{ active?: boolean }>`
//   display: flex;
//   align-items: center;
//   justify-content: center;

//   width: auto;
//   height: 32px;
//   padding: 8px 12px;

//   position: relative;

//   background-color: #fff;
//   border-radius: 4px;
//   border: none;
//   box-shadow: 0 12px 26px 0 rgba(0, 0, 0, 0.06);

//   color: ${props => props.theme.text0};
//   font-size: 12px;
//   font-weight: 500;

//   cursor: pointer;

//   ${props => !props.active && inactiveDisplayButton};
// `;

// const displayOptions = [
//   {
//     key: 'my-validators',
//     label: 'My Validators',
//   },
//   {
//     key: 'all-validators',
//     label: 'All Validators',
//   },
// ];

// const assetListOptions = [
//   {
//     imageSrc: 'https://www.cryptofonts.com/img/icons/eth.svg',
//     label: 'Eth',
//     value: '20.4443 ETH',
//     id: 1,
//   },
//   {
//     imageSrc: 'https://www.cryptofonts.com/img/icons/usdc.svg',
//     label: 'Usd Coin',
//     value: '21.4423 ETH',
//     id: 2,
//   },
//   {
//     imageSrc: 'https://www.cryptofonts.com/img/icons/bnb.svg',
//     label: 'Binance Usd',
//     value: '24.4423 ETH',
//     id: 3,
//   },
//   {
//     imageSrc: 'https://www.cryptofonts.com/img/icons/usdt.svg',
//     label: 'Tether Usd',
//     value: '28.4423 ETH',
//     id: 4,
//   },
//   {
//     imageSrc: 'https://www.cryptofonts.com/img/icons/wxt.svg',
//     label: 'Wirex',
//     value: '21.4723 ETH',
//     id: 5,
//   },
//   {
//     imageSrc: 'https://www.cryptofonts.com/img/icons/doge.svg',
//     label: 'Dogecoin',
//     value: '21.5423 ETH',
//     id: 6,
//   },
//   {
//     imageSrc: 'https://www.cryptofonts.com/img/icons/shib.svg',
//     label: 'Shiba',
//     value: '28.1423 ETH',
//     id: 7,
//   },
// ];

export function StakingTab() {
  // const [display, setDisplay] = useState('my-validators');
  // const [expanded, setExpanded] = useState(false);
  // const [query, setQuery] = useState('');

  // const isVisible = expanded ? 'none' : 'inherit';

  // const handleExpanded = (isExpanded: boolean) => {
  //   setExpanded(isExpanded);
  // };

  return (
    <Layout>
      <div>
        {/*<StakingHeader>
          <ButtonsWrapper style={{ display: isVisible }}>
            {displayOptions.map(button => (
              <DisplayButton
                type="button"
                key={button.key}
                active={display === button.key}
                onClick={() => setDisplay(button.key)}
              >
                {button.label}
              </DisplayButton>
            ))}
          </ButtonsWrapper>
          <SearchSelectWrapper>
            <Search
              placeholder="Type to search for assets"
              closeable
              expanded={expanded}
              query={query}
              setExpanded={handleExpanded}
              setQuery={setQuery}
            />
            <SelectFilterWrapper style={{ display: isVisible }}>
              <SelectAssets assetsList={assetListOptions} />
            </SelectFilterWrapper>
          </SearchSelectWrapper>
        </StakingHeader> */}

        <StakingTable />
      </div>
      <Sidebar>
        <StakingSidebar />
      </Sidebar>
    </Layout>
  );
}
